import {useGetOfferDetailQuery} from "../../offer/api/get_offer_detail";
import {useGetPropertyDetailQuery} from "../../property/api/get_property_detail";
import {useAppSelector} from "../../store/hooks";
import {IUnlockChoiceData} from "../types/IUnlockChoiceData";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";
import {getUnlockChoicePrice} from "../utils/get_unlock_choice_price";
import {isUnlockChoiceOfferOrReservation} from "../utils/is_unlock_choice_offer_or_reservation";

interface IUseUnlockChoiceDataParams {
    entryPoint?: UnlockChoiceEntryPoint;
    isEnabled: boolean;
}

interface IUnlockChoiceDataResult {
    isLoading: boolean;
    /** Null while loading, when disabled, or when the loaded data cannot fill the modal */
    data: IUnlockChoiceData | null;
}

export const useUnlockChoiceData = ({entryPoint, isEnabled}: IUseUnlockChoiceDataParams): IUnlockChoiceDataResult => {
    const {propertyId, offerId, vendorId: flowVendorId, leadSource} = useAppSelector((state) => state.registrationFlow);
    const pageProperty = useAppSelector((state) => state.property.property);
    const pageOffer = useAppSelector((state) => state.offerDetail.offer);

    const isPropertyLevel = isEnabled && Boolean(propertyId);
    const isPageProperty = isPropertyLevel && pageProperty?.id === propertyId;
    const {data: fetchedProperty, isLoading: isPropertyLoading} = useGetPropertyDetailQuery(propertyId as number, {skip: !isPropertyLevel || isPageProperty});
    const property = isPropertyLevel ? ((isPageProperty ? pageProperty : fetchedProperty) ?? null) : null;

    const isOfferLevel = isEnabled && !propertyId && Boolean(offerId);
    const pageLevelOffer = pageOffer && pageOffer.id === offerId ? pageOffer : pageProperty && pageProperty.offer.id === offerId ? pageProperty.offer : null;
    const isPageOffer = isOfferLevel && pageLevelOffer !== null;
    const {data: fetchedOffer, isLoading: isOfferLoading} = useGetOfferDetailQuery(offerId as number, {skip: !isOfferLevel || isPageOffer});
    const offer = isOfferLevel ? ((isPageOffer ? pageLevelOffer : fetchedOffer) ?? null) : null;

    const isLoading = (isPropertyLevel && !isPageProperty && isPropertyLoading) || (isOfferLevel && !isPageOffer && isOfferLoading);

    if (!isEnabled || entryPoint === undefined || isLoading) {
        return {isLoading, data: null};
    }

    const vendor = property?.offer.vendor ?? offer?.vendor ?? null;
    const vendorId = flowVendorId ?? vendor?.id ?? null;
    const price = isUnlockChoiceOfferOrReservation(entryPoint) ? getUnlockChoicePrice(property) : null;
    const plan = property?.plan ?? null;

    const isUnavailable =
        vendorId === null ||
        (entryPoint === UnlockChoiceEntryPoint.LEAD && leadSource === undefined) ||
        (entryPoint === UnlockChoiceEntryPoint.FLOOR_PLAN && !plan);

    if (isUnavailable) {
        return {isLoading: false, data: null};
    }

    return {
        isLoading: false,
        data: {
            vendorId,
            vendorName: vendor?.name || null,
            price,
            plan,
            propertyNumber: property?.number || null,
            offerType: property?.offer.type ?? offer?.type ?? null,
            // The price negotiation belongs only to the offer / reservation choice - the content choices close without it
            isPriceNegotiationAvailable: price !== null
        }
    };
};
import {useGetOfferDetailQuery} from "../../offer/api/get_offer_detail";
import {useGetPropertyDetailQuery} from "../../property/api/get_property_detail";
import {useAppSelector} from "../../store/hooks";
import {IUnlockChoiceData} from "../types/IUnlockChoiceData";
import {UnlockChoiceEntryPoint} from "../types/UnlockChoiceEntryPoint";
import {getUnlockChoicePrice} from "../utils/get_unlock_choice_price";
import {isUnlockChoiceOfferOrReservation} from "../utils/is_unlock_choice_offer_or_reservation";

interface IUseUnlockChoiceDataParams {
    entryPoint?: UnlockChoiceEntryPoint;
    isEnabled: boolean;
}

interface IUnlockChoiceDataResult {
    isLoading: boolean;
    /** Null while loading, when disabled, or when the loaded data cannot fill the modal */
    data: IUnlockChoiceData | null;
}

export const useUnlockChoiceData = ({entryPoint, isEnabled}: IUseUnlockChoiceDataParams): IUnlockChoiceDataResult => {
    const {propertyId, offerId, vendorId: flowVendorId, leadSource} = useAppSelector((state) => state.registrationFlow);
    const pageProperty = useAppSelector((state) => state.property.property);
    const pageOffer = useAppSelector((state) => state.offerDetail.offer);

    const isPropertyLevel = isEnabled && Boolean(propertyId);
    const isPageProperty = isPropertyLevel && pageProperty?.id === propertyId;
    const {data: fetchedProperty, isLoading: isPropertyLoading} = useGetPropertyDetailQuery(propertyId as number, {skip: !isPropertyLevel || isPageProperty});
    const property = isPropertyLevel ? ((isPageProperty ? pageProperty : fetchedProperty) ?? null) : null;

    const isOfferLevel = isEnabled && !propertyId && Boolean(offerId);
    const pageLevelOffer = pageOffer && pageOffer.id === offerId ? pageOffer : pageProperty && pageProperty.offer.id === offerId ? pageProperty.offer : null;
    const isPageOffer = isOfferLevel && pageLevelOffer !== null;
    const {data: fetchedOffer, isLoading: isOfferLoading} = useGetOfferDetailQuery(offerId as number, {skip: !isOfferLevel || isPageOffer});
    const offer = isOfferLevel ? ((isPageOffer ? pageLevelOffer : fetchedOffer) ?? null) : null;

    const isLoading = (isPropertyLevel && !isPageProperty && isPropertyLoading) || (isOfferLevel && !isPageOffer && isOfferLoading);

    if (!isEnabled || entryPoint === undefined || isLoading) {
        return {isLoading, data: null};
    }

    const vendor = property?.offer.vendor ?? offer?.vendor ?? null;
    const vendorId = flowVendorId ?? vendor?.id ?? null;
    const price = isUnlockChoiceOfferOrReservation(entryPoint) ? getUnlockChoicePrice(property) : null;
    const plan = property?.plan ?? null;

    const isUnavailable =
        vendorId === null ||
        (entryPoint === UnlockChoiceEntryPoint.LEAD && leadSource === undefined) ||
        (entryPoint === UnlockChoiceEntryPoint.FLOOR_PLAN && !plan);

    if (isUnavailable) {
        return {isLoading: false, data: null};
    }

    return {
        isLoading: false,
        data: {
            vendorId,
            vendorName: vendor?.name || null,
            price,
            plan,
            propertyNumber: property?.number || null,
            offerType: property?.offer.type ?? offer?.type ?? null,
            // The price negotiation belongs only to the offer / reservation choice - the content choices close without it
            isPriceNegotiationAvailable: price !== null
        }
    };
};
